import React, { useState } from 'react';
import { Button } from '../components/UI/Button';
import { Dialog } from '../components/UI/Dialog';
export const WaitingRoom = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [formStep, setFormStep] = useState<'form' | 'whatsapp'>('form');
  const handleJoinWhatsApp = () => {
    window.open('https://chat.whatsapp.com/KuVilCGv5Zn8KqDmdOUoee', '_blank');
  };
  const handleFormComplete = () => {
    setFormStep('whatsapp');
  };
  const handleCloseDialog = () => {
    setIsFormOpen(false);
    setFormStep('form'); // Reset to form step when dialog is closed
  };
  return <div className="pt-20 bg-white" data-id="element-4974" data-mp="1xj4lbfgdj67q">
      <section className="relative py-16 border-b border-gray-200" data-id="element-4975" data-mp="1xm8xp03zt89h">
        <div className="absolute inset-0 z-0" data-id="element-4976" data-mp="1sme6swk7wiof">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/veE5AXEU4CEztbBqZpUQcx/coverrs.png" alt="The Networking Salon" className="w-full h-full object-cover grayscale" data-id="element-4977" data-mp="1snfldb0fznaw" />
          <div className="absolute inset-0 bg-black bg-opacity-50" data-id="element-4978" data-mp="21joiuk4v0bue"></div>
        </div>
        <div className="container mx-auto px-4 relative z-10" data-id="element-4979" data-mp="1y53r9ckcva5t">
          <div className="max-w-3xl mx-auto text-center" data-id="element-4980" data-mp="231u47r0v5pn0">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6" data-id="element-4981" data-mp="234gkcf1tldgu">
              The Waiting Room
            </h1>
            <p className="text-xl text-gray-200 mb-8" data-id="element-4982" data-mp="2d135z61z08jx">
              Your first step into The Networking Salon community
            </p>
          </div>
        </div>
      </section>
      <section className="py-16" data-id="element-4983" data-mp="2m180ifm2fcgo">
        <div className="container mx-auto px-4" data-id="element-4984" data-mp="2m0g7ncjursu3">
          <div className="max-w-3xl mx-auto" data-id="element-4985" data-mp="2lz54ney8ep41">
            <div className="bg-white p-6 rounded-lg border-2 border-gray-300 mb-8" data-id="element-4986" data-mp="2qt9afuvrgr3j">
              <h2 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-4987" data-mp="2vrkiq16eqtjn">
                🌿 The Networking Salon — The Waiting Room
              </h2>
              <p className="text-gray-700 mb-6" data-id="element-4988" data-mp="30oayeneavn4j">Welcome to The Waiting Room!</p>
              <p className="text-gray-700 mb-4" data-id="element-4989" data-mp="34sioop0epb4v">
                We're excited to have you here — this is your first step into
                The Networking Salon community. Think of this as the lounge
                before the salon: a warm, open space where curiosity meets
                connection.
              </p>
              <p className="text-gray-700 mb-4" data-id="element-4990" data-mp="1ehnl7t3ub8ok">
                The Waiting Room is where you get to experience the heartbeat of
                our ecosystem — a community that values genuine relationships,
                thoughtful collaboration, and opportunities that help you grow.
              </p>
              <p className="text-gray-700 mb-4" data-id="element-4991" data-mp="1jh04k3vi5xme">
                Here, you can connect with other professionals and creatives,
                share relevant opportunities, and get a taste of what it means
                to be part of a high-trust network of culture shapers.
              </p>
              <p className="text-gray-700 mb-4" data-id="element-4992" data-mp="327biuqmfgzh">
                When you're ready, you can choose to step deeper into the main
                community — where you'll access masterclasses, curated
                masterminds, and mentorship from business leaders and creators.
                But for now, this is your launchpad.
              </p>
              <h3 className="text-xl font-bold text-gray-800 mt-8 mb-4" data-id="element-4993" data-mp="3b9dn5v5jmwse">
                💬 How to Engage in The Waiting Room
              </h3>
              <div className="space-y-4 mb-8" data-id="element-4994" data-mp="3g7f7skimb45z">
                <div className="flex items-start" data-id="element-4995" data-mp="31bzfol1llic8">
                  <span className="mr-2" data-id="element-4996" data-mp="31elp6q81u7x3">🌟</span>
                  <p className="text-gray-700" data-id="element-4997" data-mp="36cetfdpskruq">
                    <strong data-id="element-4998" data-mp="368zcs6ggzar7">Share Opportunities</strong> If you come across a
                    job, grant, training, or collaboration that could help
                    others — share it here! The Waiting Room thrives on
                    generosity and connection.
                  </p>
                </div>
                <div className="flex items-start" data-id="element-4999" data-mp="vjajzn50sj6e">
                  <span className="mr-2" data-id="element-5000" data-mp="vhzffl3r37e8">📣</span>
                  <p className="text-gray-700" data-id="element-5001" data-mp="2rmfexcrc9hl6">
                    <strong data-id="element-5002" data-mp="2rl462yj1djn7">Promote with Purpose</strong> You can post your own
                    announcements, events, or ads — just make sure they add
                    value to the community. All promotional content will be
                    reviewed by the admin before it goes live.
                  </p>
                </div>
                <div className="flex items-start" data-id="element-5003" data-mp="2dp0g5hf73xgj">
                  <span className="mr-2" data-id="element-5004" data-mp="28omhgpzhhzv6">💡</span>
                  <p className="text-gray-700" data-id="element-5005" data-mp="23wus2is2e06m">
                    <strong data-id="element-5006" data-mp="23w2vb4mqdwer">Start Conversations</strong> Ask thoughtful
                    questions, share insights, and engage in discussions that
                    spark ideas. The best connections begin with authentic
                    dialogue.
                  </p>
                </div>
                <div className="flex items-start" data-id="element-5007" data-mp="1pw1v7reait0c">
                  <span className="mr-2" data-id="element-5008" data-mp="1ky0cj7ks0vpe">🤝</span>
                  <p className="text-gray-700" data-id="element-5009" data-mp="1kzbfj56edzfg">
                    <strong data-id="element-5010" data-mp="fy87ceysl1j">Network Intentionally</strong> Introduce yourself,
                    tell us what you're working on, and connect with others who
                    share your vision. The Waiting Room is full of people
                    building, learning, and creating just like you.
                  </p>
                </div>
                <div className="flex items-start" data-id="element-5011" data-mp="eeo6gvdisqrh">
                  <span className="mr-2" data-id="element-5012" data-mp="edd14r4ffay9">🌱</span>
                  <p className="text-gray-700" data-id="element-5013" data-mp="3dvvxsw7vjoys">
                    <strong data-id="element-5014" data-mp="3dt1dd4ov245d">Stay Curious</strong> Use this space to explore —
                    watch how people connect, notice the kinds of conversations
                    happening, and learn how The Networking Salon cultivates
                    trust and collaboration.
                  </p>
                </div>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mt-8 mb-4" data-id="element-5015" data-mp="2u7n066nkaqrw">
                🌍 Why The Waiting Room Matters
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-5016" data-mp="2z3vddei789wf">
                The Waiting Room isn't just a holding space — it's a preview of
                what's possible when you engage intentionally. It's where:
              </p>
              <ul className="list-disc list-inside text-gray-700 mb-6 pl-4" data-id="element-5017" data-mp="f3rz58zdng10">
                <li data-id="element-5018" data-mp="f5w13ldpu4yn">New voices meet opportunity</li>
                <li data-id="element-5019" data-mp="b1y35e04n076">Ideas start taking shape</li>
                <li data-id="element-5020" data-mp="b4asic87scu9">Collaborations begin</li>
                <li data-id="element-5021" data-mp="3jh8067p5tf83">And relationships grow before they're formalized</li>
              </ul>
              <p className="text-gray-700 mb-6" data-id="element-5022" data-mp="3ejg8nesffv4f">
                By being here, you're already part of something meaningful — a
                movement built on connection, creativity, and contribution.
              </p>
              <p className="text-gray-700 mb-6 font-medium" data-id="element-5023" data-mp="3nijqkffuy4hc">
                Welcome to the start of your journey. The conversation begins
                here. The opportunity begins with you.
              </p>
              <div className="bg-gray-100 p-4 rounded-lg border border-gray-300 text-center" data-id="element-5024" data-mp="12skqes520zpa">
                <p className="text-gray-700 mb-4 font-medium" data-id="element-5025" data-mp="1b9lc3rfde39w">
                  Ready to join The Waiting Room?
                </p>
                <p className="text-gray-700 mb-6" data-id="element-5026" data-mp="1f9vih572qvpa">
                  Complete the registration form and then join our WhatsApp
                  group to access the community.
                </p>
                <Button onClick={() => setIsFormOpen(true)} data-id="element-5027" data-mp="16de4zvb8mlqd">
                  Join The Waiting Room
                </Button>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Form Dialog */}
      <Dialog isOpen={isFormOpen} onClose={handleCloseDialog} title={formStep === 'form' ? 'Join The Waiting Room' : 'Complete Your Registration'} size="lg" data-id="element-5028" data-mp="1kbcikyhqie4t">
        {formStep === 'form' ? <div className="p-4" data-id="element-5029" data-mp="2czqf19t6d2e9">
            <div className="w-full mb-6" data-id="element-5030" data-mp="2czgl5b50eb3a">
              <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSdr_5jvYO4hJncEC0hjHQweFJSh8FFpzrBhsjQvCQemuZT7MA/viewform?embedded=true" width="100%" height="600" frameBorder="0" marginHeight={0} marginWidth={0} data-id="element-5031" data-mp="2cyf7r00itcie">
                Loading…
              </iframe>
            </div>
            <div className="bg-gray-100 p-4 rounded-lg border border-gray-300 text-center" data-id="element-5032" data-mp="cvxnztcreksh">
              <p className="text-gray-700 mb-4" data-id="element-5033" data-mp="7z7939coxv8n">
                <strong data-id="element-5034" data-mp="3wslyd1zo9bk">Step 1 of 2:</strong> Complete the form above, then
                click the button below to continue.
              </p>
              <Button onClick={handleFormComplete} className="mb-2" data-id="element-5035" data-mp="10lrzo7lce3b5">
                I've Completed the Form
              </Button>
            </div>
          </div> : <div className="p-4" data-id="element-5036" data-mp="rm4vje18ajee">
            <div className="bg-gray-100 p-6 rounded-lg border-2 border-gray-300 text-center" data-id="element-5037" data-mp="rlbyx5vzha9z">
              <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-5038" data-mp="mm8qrckpinxs">
                Thank you for joining The Waiting Room!
              </h3>
              <p className="text-gray-700 mb-6" data-id="element-5039" data-mp="3caj7dtgb91h1">
                <strong data-id="element-5040" data-mp="37d9icewu2rtq">Step 2 of 2:</strong> Click the button below to join our
                WhatsApp group and complete your registration.
              </p>
              <Button onClick={handleJoinWhatsApp} className="mb-4" data-id="element-5041" data-mp="1mtnmty3tulpb">
                Join WhatsApp Group
              </Button>
              <p className="text-sm text-gray-500" data-id="element-5042" data-mp="1vvn32o70plr7">
                If the button doesn't work, copy this link:
                <br data-id="element-5043" data-mp="20n593qnwecj1" />
                <span className="font-medium break-all" data-id="element-5044" data-mp="20og9rhm1r45x">
                  https://chat.whatsapp.com/KuVilCGv5Zn8KqDmdOUoee
                </span>
              </p>
            </div>
          </div>}
      </Dialog>
    </div>;
};